const typoUserMyAccount = {
  title: 'Mi Cuenta',
  config: 'Ajustes',
  profileError: 'Espere a que se cargue el archivo',
  name: 'Nombre',
  password: 'Contraseña',
  label: 'Recibir emails automáticos',
  automaticEmailsHelperTitle: 'Esta configuración controla la recepción de los siguientes emails:',
  automaticEmailsHelperWeeklyServicesReport: 'Informe semanal de servicios',
  automaticEmailsHelperWeeklyActionsReport: 'Informe semanal de acciones',
  automaticEmailsHelperActionCompleted: 'Conclusión de la acción, para su creador (y administradores, cuando la feature flag está activa)',
  automaticEmailsHelperActionAssigned: 'Creación de la acción, para sus responsables',
  coordinatesLabel: 'Mostrar coordenadas, mapa y fecha de creación in el informe del servicio',
};

export default typoUserMyAccount;
